import React, { useMemo, useState } from 'react';
import styled from 'styled-components';
import { MenuItem, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { FormMultiSelect } from '../../fields/FormMultiSelect';
import { useFormContext } from '../../FormContext';
export var DataConditionOperator;
(function (DataConditionOperator) {
    DataConditionOperator["Equal"] = "equal";
    DataConditionOperator["NotEqual"] = "not-equal";
    DataConditionOperator["HasValue"] = "has-value";
    DataConditionOperator["GreaterThan"] = "greater-than";
    DataConditionOperator["LessThan"] = "less-than";
})(DataConditionOperator || (DataConditionOperator = {}));
const StyledConfiguratorDiv = styled.div `
  .field {
    margin-bottom: 12px;
  }
`;
const DataConditionConfigurator = ({ condition, onChange }) => {
    var _a, _b;
    const { entitySchema, formState, trackChanges } = useFormContext();
    const { selectedStateNode } = formState;
    const [params, setParams] = useState(condition.params || { operator: DataConditionOperator.Equal });
    const column = useMemo(() => {
        var _a;
        return (_a = entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns) === null || _a === void 0 ? void 0 : _a.find(column => column.name === params.schemaColumnName);
    }, [entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns, params.schemaColumnName]);
    const formElement = useMemo(() => {
        var _a, _b, _c, _d;
        let formElement = undefined;
        if (params.schemaColumnName) {
            // find form element in current section
            formElement = (_b = (_a = selectedStateNode === null || selectedStateNode === void 0 ? void 0 : selectedStateNode.meta) === null || _a === void 0 ? void 0 : _a.elements) === null || _b === void 0 ? void 0 : _b.find(element => element.dataSource === params.schemaColumnName);
            // if not found find element in all sections
            if (!formElement && trackChanges.final.states) {
                for (const stateNode of trackChanges.final.states) {
                    formElement = (_d = (_c = stateNode === null || stateNode === void 0 ? void 0 : stateNode.meta) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.find(element => element.dataSource === params.schemaColumnName);
                    if (formElement) {
                        break;
                    }
                }
            }
            return formElement;
        }
    }, [
        params.schemaColumnName,
        (_a = selectedStateNode === null || selectedStateNode === void 0 ? void 0 : selectedStateNode.meta) === null || _a === void 0 ? void 0 : _a.elements,
        trackChanges.final.states
    ]);
    const operators = useMemo(() => {
        const operators = [
            { value: DataConditionOperator.Equal, label: 'Equal (=)' },
            { value: DataConditionOperator.NotEqual, label: 'Not Equal (!=)' },
            { value: DataConditionOperator.HasValue, label: 'Has Value' }
        ];
        if (column &&
            (['integer', 'date', 'time'].includes(column.type) ||
                column.type.includes('numeric'))) {
            operators.push({
                value: DataConditionOperator.GreaterThan,
                label: 'Greater Than (>)'
            });
            operators.push({
                value: DataConditionOperator.LessThan,
                label: 'Less Than (<)'
            });
        }
        return operators;
    }, [column]);
    return (React.createElement(StyledConfiguratorDiv, null,
        React.createElement(Autocomplete, { fullWidth: true, disableClearable: true, className: 'field', getOptionLabel: column => (column === null || column === void 0 ? void 0 : column.displayName) || '', getOptionSelected: (column, value) => (column === null || column === void 0 ? void 0 : column.name) === (value === null || value === void 0 ? void 0 : value.name), value: (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns.find(column => { var _a; return column.name === ((_a = condition.params) === null || _a === void 0 ? void 0 : _a.schemaColumnName); })) || null, options: (entitySchema === null || entitySchema === void 0 ? void 0 : entitySchema.columns) || [], onChange: (_, value) => {
                const schemaColumnName = value.name;
                params.schemaColumnName = schemaColumnName;
                params.values = [];
                condition.params = params;
                setParams(Object.assign({}, params));
                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
            }, renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', label: 'Schema Column' }))) }),
        React.createElement(TextField, { select: true, fullWidth: true, size: 'small', variant: 'outlined', label: 'Operator', className: 'field', value: (params === null || params === void 0 ? void 0 : params.operator) || DataConditionOperator.Equal, onChange: event => {
                params.operator = event.target.value;
                condition.params = params;
                if (condition.params.operator === DataConditionOperator.HasValue) {
                    delete condition.params.values;
                }
                setParams(Object.assign({}, params));
                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
            } }, operators.map(operator => (React.createElement(MenuItem, { key: operator.value, value: operator.value }, operator.label)))),
        (params === null || params === void 0 ? void 0 : params.operator) === DataConditionOperator.HasValue &&
            (formElement === null || formElement === void 0 ? void 0 : formElement.type) === 'MultiSelect' && (React.createElement(TextField, { fullWidth: true, type: 'number', size: 'small', variant: 'outlined', label: 'Number of selected values?', value: ((_b = params.values) === null || _b === void 0 ? void 0 : _b[0]) || '', onChange: event => {
                params.values = [event.target.value];
                condition.params = params;
                setParams(Object.assign({}, params));
                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
            } })),
        (params === null || params === void 0 ? void 0 : params.operator) !== DataConditionOperator.HasValue &&
            (() => {
                var _a;
                let type = 'text';
                switch (formElement === null || formElement === void 0 ? void 0 : formElement.type) {
                    case 'RadioGroup':
                    case 'Boolean':
                    case 'MultiSelect':
                    case 'Select':
                        return (React.createElement(FormMultiSelect, { stateNode: selectedStateNode, element: formElement, values: params.values || [], onChange: (event, option) => {
                                event.preventDefault();
                                const values = params.values || [];
                                const index = values.indexOf(option.value);
                                if (index > -1) {
                                    values.splice(index, 1);
                                }
                                else {
                                    values.push(option.value);
                                }
                                params.values = values;
                                condition.params = params;
                                setParams(Object.assign({}, params));
                                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                            } }));
                    case 'Slider':
                    case 'NumberField':
                        type = 'number';
                    case 'Date':
                    case 'Time':
                    default:
                        return (React.createElement(TextField, { type: type, fullWidth: true, size: 'small', variant: 'outlined', label: 'Value', value: ((_a = params.values) === null || _a === void 0 ? void 0 : _a[0]) || '', onChange: event => {
                                params.values = [event.target.value];
                                condition.params = params;
                                setParams(Object.assign({}, params));
                                onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                            } }));
                }
            })()));
};
const StyledDisplayDiv = styled.div `
  font-size: 13px;
  padding-left: 4px;
  text-indent: -4px;
  code {
    background: #f4f5fa;
    padding: 2px 5px;
    border-radius: 3px;
  }
  b {
    padding: 0 5px 0 0;
  }
  i {
  }
`;
const DataConditionDisplay = ({ condition }) => {
    const { params } = condition;
    return (React.createElement(StyledDisplayDiv, null,
        React.createElement("code", null, params === null || params === void 0 ? void 0 : params.schemaColumnName),
        React.createElement("b", null, (() => {
            var _a;
            switch (params === null || params === void 0 ? void 0 : params.operator) {
                case DataConditionOperator.HasValue:
                    const count = ((_a = params === null || params === void 0 ? void 0 : params.values) === null || _a === void 0 ? void 0 : _a[0]) || 0;
                    if (count > 0) {
                        return `has at least ${count} value${count > 1 ? 's' : ''}`;
                    }
                    else {
                        return 'has a value';
                    }
                case DataConditionOperator.NotEqual:
                    return '!=';
                case DataConditionOperator.GreaterThan:
                    return '>';
                case DataConditionOperator.LessThan:
                    return '<';
                default:
                    return '=';
            }
        })()),
        (params === null || params === void 0 ? void 0 : params.operator) !== DataConditionOperator.HasValue &&
            (params === null || params === void 0 ? void 0 : params.values) &&
            params.values.length > 0 && React.createElement("i", null, params.values.join(', '))));
};
export const DataConditionPlugin = {
    type: 'Data Condition',
    configurator: DataConditionConfigurator,
    display: DataConditionDisplay,
    validate: (condition) => {
        return true;
    },
    guard: (state, params) => {
        var _a, _b, _c;
        const value = (_a = state.context.formValues) === null || _a === void 0 ? void 0 : _a[params.schemaColumnName];
        switch (params === null || params === void 0 ? void 0 : params.operator) {
            case DataConditionOperator.HasValue:
                if (params.values && params.values.length > 0) {
                    // check if at lease X number of items selected
                    return Array.isArray(value) && value.length >= +params.values;
                }
                else if (Array.isArray(value)) {
                    return value.length > 0;
                }
                else {
                    return typeof value !== 'undefined';
                }
            case DataConditionOperator.NotEqual: {
                const values = Array.isArray(value) ? value : [value];
                if (values.length === 0)
                    return false;
                for (const value of values) {
                    for (const paramValue of params.values || []) {
                        if (paramValue === value) {
                            return false;
                        }
                    }
                }
                return true;
            }
            case DataConditionOperator.GreaterThan:
                return value > +(((_b = params.values) === null || _b === void 0 ? void 0 : _b[0]) || 0);
            case DataConditionOperator.LessThan:
                return value < +(((_c = params.values) === null || _c === void 0 ? void 0 : _c[0]) || 0);
            default: {
                const values = Array.isArray(value) ? value : [value];
                if (values.length === 0)
                    return false;
                for (const value of values) {
                    for (const paramValue of params.values || []) {
                        if (paramValue !== value) {
                            return false;
                        }
                    }
                }
                return true;
            }
        }
    }
};
//# sourceMappingURL=DataCondition.js.map